import React from 'react';
import * as SC from 'SC/App.sc';

export const LongText = ({ value }) => (
  <SC.LongText title={value}>{value}</SC.LongText>
);
